<template>
    <div class="header-bar-medical-device-item-wrapper">
        <v-menu
            v-model="settings"
            v-if="getRole"
            content-class="border-color-invisible border-radius-9"
            :nudge-width="nudgeWidth"
            class="menu-settings"
            absolute
            bottom
            :nudge-left="nudgeLeft"
            :nudge-top="nudgeTop"
            offset-x
            :close-on-content-click="false"
        >
            <svg-button
                slot="activator"
                id="settings-menu-activator"
            >
                <template>
                    <settings-icon class="settings"/>
                </template>
            </svg-button>
            <v-card id="menu-card-id" class="dropdown-card">
                <v-list class="account-settings settings-menu-list">
                    <v-list-tile>
                        <v-list-tile-content class="font-size-default color-body">{{text('api.language.title')}}</v-list-tile-content>
                    </v-list-tile>
                    <v-radio-group
                        name="language-radio-group"
                        style="padding-top: 0; padding-bottom: 10px"
                        v-model="selectedLang">
                        <div
                            @click="changeLanguage(language.key)"
                            class="radio-button-wrapper"
                            v-for="language in languageListForDropdown">
                            {{language.name}}
                            <v-radio
                                color="aqua"
                                :key="language.key"
                                :value="language.key"
                                :id="language.key"
                                @change="changeLanguage"
                            >
                            </v-radio>
                        </div>

                    </v-radio-group>
                    <v-divider></v-divider>

                    <v-list-tile>
                        <v-list-tile-content class="font-size-default color-body">{{ text('api.theme.title') }}</v-list-tile-content>
                    </v-list-tile>
                    <v-radio-group
                        name="theme-radio-group"
                        style="padding-top: 0;padding-bottom: 10px"
                        v-model="selectedTheme"
                    >
                        <div
                            class="radio-button-wrapper"
                            @click="changeTheme(theme.value)"
                            v-for="theme in getThemeList"
                        >
                            <div class="icon-text-wrapper">
                                <light-theme-icon v-if="theme.value === lightTheme"/>
                                <dark-theme-icon v-if="theme.value === darkTheme"/>
                                <high-contrast-light-icon v-if="theme.value === lightThemeHighContrast"/>
                                <high-contrast-dark-icon v-if="theme.value === darkThemeHighContrast"/>
                                <p class="color-headings-text" style="margin: 0 0 0 15px;">{{theme.name}}</p>
                            </div>

                            <v-radio
                                :key="theme.value"
                                :value="theme.value"
                                :id="theme.value"
                            >
                            </v-radio>
                        </div>

                    </v-radio-group>

                    <v-divider v-if="getAppPropertyValueArray('GUI_VARIANTS_AVAILABLE').length === 2 && !isPFI && showSwitches && appType !=='PF_CHATBOT_STUDY' && appType !=='PF_CHATBOT' && appType !== 'PF_CHATBOT_PUBLIC'"></v-divider>
                    <v-list-tile
                        v-if="getAppPropertyValueArray('GUI_VARIANTS_AVAILABLE').length === 2 && !isPFI && showSwitches && appType !=='PF_CHATBOT_STUDY' && appType !=='PF_CHATBOT' && appType !== 'PF_CHATBOT_PUBLIC'">
                        <v-list-tile-content
                            class="switch-action-wrapper"
                        >
                            {{text('api.pro.priorityList')}}
                            <BaseSwitch v-model="mustShowAssessmentList" elem-id="togglePriorityList" />
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider v-if="mustShowEvaluationSwitch"></v-divider>

                    <v-list-tile
                        v-if="mustShowEvaluationSwitch">
                        <v-list-tile-content
                            class="switch-action-wrapper"
                        >
                            {{text('api.pro.toggleEvaluationPage')}}
                            <BaseSwitch v-model="mustShowEvaluationPage" elem-id="toggleMustShowEvaluationPage" />
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>

            </v-card>
        </v-menu>
    </div>
</template>

<script>
import SvgButton from "./SvgButton";
import SettingsIcon from "../svg/shared/settingsIcon";
import LightThemeIcon from "../svg/shared/lightThemeIcon";
import DarkThemeIcon from "../svg/shared/darkThemeIcon";
import HighContrastLightIcon from "../svg/shared/highContrastLightIcon";
import HighContrastDarkIcon from "../svg/shared/highContrastDarkIcon";
import BaseSwitch from "./BaseSwitch";
import {mapGetters} from "vuex";
import Vue from "vue";
import THEMES from "../../constants/themes";
export default {
    name: "SettingsMenu",
    components: {
        BaseSwitch,
        HighContrastDarkIcon, HighContrastLightIcon, DarkThemeIcon, LightThemeIcon, SettingsIcon, SvgButton},
    props: {
      nudgeWidth: {
          type: Number,
          default: 320,
      },
      nudgeLeft: {
          type: Number,
          default: 50
      },
      nudgeTop: {
          type: Number,
          default: -30
      },
        // Provides the application type that comes with the app properties
      appType: {
          type: String,
          default: null,
      },
        // TODO Do we need this?
      getRole: {
          type: String,
          default: ' '
      },
        // We use this to detect the application header type
      isPFI: {
          type: Boolean,
          default: false
      },
        // We set this to true to hide the mustShowAssessmentList and mustShowEvaluationPage switches
      showSwitches: {
          type: Boolean,
          default: true,
      }
    },
    computed: {
        ...mapGetters({
            languageList: 'TranslationStore/getLanguageList',
            getThemeList: 'ThemeStore/getThemeList',
            getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
            getAppPropertyValueArray: 'TranslationStore/getAppPropertyValueArray'
        }),
        languageListForDropdown() {

            let langsForDropdown = [];
            this.languageList.forEach((langKey) => {
                langsForDropdown.push({
                    key: langKey,
                    name: this.text("api.language.name." + langKey)
                });
            });
            return langsForDropdown;
        },

        selectedLang: {
            get () {
                return this.$store.state["TranslationStore"].selectedLanguage;
            },
            set (newVal) {
                this.$store.commit('TranslationStore/setSelectedLanguage', newVal);
            }
        },
        selectedTheme: {
            get() {
                return this.$store.state["ThemeStore"].theme;
            },
            set() {
                // On set do nothing to avoid making double /selectTheme calls.
                // When the user click on the radio button the @changeTheme event triggers from the parent div
                // We need this empty set so Vue doesn't trigger an error
            }
        },
        mustShowAssessmentList: {
            get() {
                return this.$store.getters['SymptomsQuestionsStore/getMustShowAssessmentList'];
            },
            set(newVal) {
                this.submitChangeMustShowAssessmentList(newVal)
            }

        },
        mustShowEvaluationPage: {
            get() {
                return this.$store.getters['TranslationStore/getMustShowEvaluationPage'];
            },
            set(newVal) {
                this.submitChangeMustShowEvaluationPage(newVal);
            }
        },
        mustShowEvaluationSwitch() {
            const studyAccess = this.$store.getters['TranslationStore/getAppPropertyStudyAccess'];
            return !studyAccess && !this.isPFI && this.showSwitches && this.appType !=='PF_CHATBOT_STUDY' && this.appType !=='PF_CHATBOT' && this.appType !== 'PF_CHATBOT_PUBLIC';
        }
    },
    data() {
      return {
          settings: false,
          radioButtonPlugin: Vue.RadioButton.RadioButtonSvg,
          arrowDownPlugin: Vue.ArrowDown.arrowDownSvg,
          lightTheme: THEMES.LIGHT.VALUE,
          darkTheme: THEMES.DARK.VALUE,
          lightThemeHighContrast: THEMES.LIGHT_HIGH_CONTRAST.VALUE,
          darkThemeHighContrast: THEMES.DARK_HIGH_CONTRAST.VALUE
      }
    },
    methods :{
        changeLanguage(newLang) {
            this.$store.dispatch("TranslationStore/submitLanguageChange", newLang).then((response) => {
                window.location.reload();
            });
        },

        changeTheme(newVal) {
            let options = {};
            options.newThemeValue = newVal;
            options.isPFI = this.isPFI;
            this.$store.dispatch("ThemeStore/selectTheme", options) ;
            this.$emit('closeSideNav');
            this.settings = false;
        },
        submitChangeMustShowEvaluationPage(value) {
            this.settings = false;
            if (value) {
                this.$store.dispatch("TranslationStore/submitEvaluationPageType", true).then((response) => {

                });
            } else {
                this.$store.dispatch("TranslationStore/submitEvaluationPageType", false).then((response) => {

                });
            }
        },
        submitChangeMustShowAssessmentList(isPriorityListEnabled) {
            this.settings = false;

            this.$store.dispatch("SymptomsQuestionsStore/submitAssessmentType", isPriorityListEnabled);

            if (this.$router.currentRoute.path === '/symptoms-list' || this.$router.currentRoute.path === '/symptoms-questions') {

                if (isPriorityListEnabled) {
                    this.$router.push('/symptoms-list');
                } else {
                    this.$router.push('/symptoms-questions');
                }
                this.$store.commit('SymptomsQuestionsStore/setMustShowAssessmentList', isPriorityListEnabled);

            } else if (this.$router.currentRoute.path === '/assessment-start' || this.$router.currentRoute.path === '/assessment-start-list') {

                if (isPriorityListEnabled) {
                    this.$router.push('/assessment-start-list');
                } else {
                    this.$router.push('/assessment-start');
                }
                this.$store.commit('SymptomsQuestionsStore/setMustShowAssessmentList', isPriorityListEnabled);

            } else {
                this.$store.commit('SymptomsQuestionsStore/setMustShowAssessmentList', isPriorityListEnabled);
            }

        }
    },

    mounted() {
        let selectedInputIcon = document.getElementsByClassName('language-option');
        if (selectedInputIcon.length !== 0) {
            let selectLanguage = selectedInputIcon[0].getElementsByClassName('input-group__append-icon');
            selectLanguage[0].innerHTML = this.arrowDownPlugin();
        }

    },
    watch:{
        settings(newVal, oldValue) {
            if(newVal) {
                let settingsList = document.querySelector('ul.account-settings.settings-menu-list');

                let radio = settingsList.getElementsByClassName('icon--radio');
                for(let i = 0; i < radio.length; i++) {
                    radio[i].innerHTML = this.radioButtonPlugin();
                }

                let radioUnchecked = settingsList.getElementsByClassName('icon icon--selection-control');
                for(let i = 0; i < radioUnchecked.length; i++) {
                    const uncheckedIcon = radioUnchecked[i];
                    if (![...radio].includes(uncheckedIcon)) {
                        radioUnchecked[i].innerHTML = '';
                    }
                }

            }
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/common/components/shared/SettingsMenu.vue